import { isMobile as isMobileLib } from "is-mobile";
export function isMobileUA(ua) {
  return isMobileLib({
    ua: ua,
    tablet: true,
    // featureDetect is only available in the browser
    // https://github.com/juliangruber/is-mobile#mobile-ua-tablet-featuredetect-
    featureDetect: true
  });
}